module.exports = __webpack_public_path__ + "static/media/tamarind.637f3c10.png";